export const config = {
  date: 'M/D/YYYY h:mm:ss a',
  date_format: 'yyyy-MM-dd',
  date_delivery: 'EEE_MM/dd'
}